import LoadMore from "../plugins/load-more";

new LoadMore('.block-homepage-news', '.block-homepage-news .load-more');
